// TIMERS

import Environment from 'entities/Environment'

const oldDataTimeoutInHours = 24 // (in hours)

const storageIntervalInMs = 1000 // (in ms)

const millisecondToRetryRequestSending = 3000

const millisecondsBetweenMessagesAppear = 200

const inputAnimationDelay = 600

const mobileBreakpoint = 640

const shortViewportBreakpoint = 340
const checkVerificationDelay = 5000

const sentryWhitelistUrls = [/https:\/\/.*sae-conversational\.com/]

const buttonDataId = 'sae-conversational-button'
const rootId = 'sae-conversational-widget'

enum UrlHashesFragments {
  SupportChat = 'support-chat',
  SupportChatNotifications = 'support-chat-notification',
}

enum UrlGetParams {
  SupportChat = 'support-chat',
  SupportChatNotifications = 'support-chat-notification',
  ViewProduct = 'view-product',
  TriggerIntent = 'trigger-intent',
  Product = 'product',
  Tenant = 'tenant',
  Language = 'language',
}

enum MobileAppQueryParams {
  OS = 'os',
  OSVersion = 'osversion',
  Device = 'device',
  AppVersion = 'appVersion',
  LoginInfo = 'logininfo',
  URL = 'url',
  Step = 'step',
  AmountOfCards = 'cards',
  ICCSN = 'iccsn',
  TwoFA = '2fa',
  Process = 'process',
}

enum SentryExtraKeys {
  ErrorRequestBody = 'Error body',
  FailedAnalyticsRequest = 'Failed analytics request',
}

enum WidgetModes {
  Default = 'default',
  MobileApp = 'mobileapp',
}

enum AppCampaign {
  Default = 'default',
  eRX = 'erx',
}

enum AppDevices {
  Android = 'android',
  iOS = 'ios',
}

const deviceQueryStringName = 'device'

const myOrdersPath = '/nx/account/orders/'

const shouldSentryInitialize =
  process.env.REACT_APP_SENTRY_DSN &&
  process.env.REACT_APP_VERSION &&
  process.env.NODE_ENV === Environment.production

const maxFileUploadSize = 5242880 // 5 MB

const themeTransitionDuration = 400

const defaultUserlikeGroup = 'default'

export {
  oldDataTimeoutInHours,
  storageIntervalInMs,
  millisecondToRetryRequestSending,
  millisecondsBetweenMessagesAppear,
  inputAnimationDelay,
  buttonDataId,
  rootId,
  mobileBreakpoint,
  UrlHashesFragments,
  shortViewportBreakpoint,
  checkVerificationDelay,
  SentryExtraKeys,
  sentryWhitelistUrls,
  UrlGetParams,
  myOrdersPath,
  shouldSentryInitialize,
  maxFileUploadSize,
  WidgetModes,
  AppCampaign as MobileAppCampaign,
  AppDevices,
  deviceQueryStringName,
  themeTransitionDuration,
  defaultUserlikeGroup,
  MobileAppQueryParams,
}
